import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["content", "onClickDiscard", "discardButtonText", "onClickCancel", "cancelButtonText", "onClickConfirm", "confirmButtonText"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import Dialog from './Dialog';
import baseDialogPropTypes from './baseDialogPropTypes';

/*
 * Save dialog component to save, discard or cancel an action
 */
var SaveDialog = function SaveDialog(props) {
  var content = props.content,
    onClickDiscard = props.onClickDiscard,
    discardButtonText = props.discardButtonText,
    onClickCancel = props.onClickCancel,
    cancelButtonText = props.cancelButtonText,
    onClickConfirm = props.onClickConfirm,
    confirmButtonText = props.confirmButtonText,
    remainingProps = _objectWithoutProperties(props, _excluded);
  var footer = /*#__PURE__*/React.createElement("div", {
    className: "display-flex justify-content-end btn-toolbar"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "DiscardButton btn btn-default",
    onClick: onClickDiscard
  }, discardButtonText), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "CancelButton btn btn-default",
    onClick: onClickCancel
  }, cancelButtonText), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "ConfirmationButton btn btn-primary",
    onClick: onClickConfirm
  }, confirmButtonText));
  return /*#__PURE__*/React.createElement(Dialog, _extends({}, remainingProps, {
    body: content,
    footer: footer,
    onHide: onClickCancel,
    className: "save-dialog",
    disableEsc: true
  }));
};
SaveDialog.defaultProps = {
  show: false,
  showCloseButton: true,
  onClickCancel: function onClickCancel() {},
  onClickConfirm: function onClickConfirm() {},
  onClickDiscard: function onClickDiscard() {}
};
SaveDialog.propTypes = _objectSpread(_objectSpread({}, baseDialogPropTypes), {}, {
  content: PropTypes.node,
  onClickCancel: PropTypes.func.isRequired,
  onClickDiscard: PropTypes.func.isRequired,
  onClickConfirm: PropTypes.func.isRequired,
  discardButtonText: PropTypes.node.isRequired,
  cancelButtonText: PropTypes.node.isRequired,
  confirmButtonText: PropTypes.node.isRequired
});
export default SaveDialog;